import bootstrap from './bootstrap';
import register from './register';
import services from './services';

export default {
  bootstrap,
  register,
  services,
};
